import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
/** Reducers Import */
import { BookmarkActions } from "../../services/Redux/BookmarkReducer";
/** Services Impaort */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
import IndexedDb from "../../services/IndexedDb/IndexedDb";
/** Components Import */
import { Loading, Button, Dropdown, Dialog, Radio, Checkbox } from "../../Components/Bootstrap";
import { Stack, Card } from "react-bootstrap";
import Terms from "../Login/Terms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/** Icons Import */
import { faStar, faRotateRight } from "@fortawesome/free-solid-svg-icons";

function ChangeCar() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [reloadTime, setReloadTime] = useState(Commons.Storages("get", "saves").reloadTime);
  const bookmarkStates = useSelector((state) => state.Bookmarks);
  const [userInfo, setUserInfo] = useState("");
  const [selectedBusTitle, setSelectedBusTitle] = useState("버스를 선택하세요.");
  const [selectBusValue, setSelectBusValue] = useState(""); // 선택한 노선
  const [routes, setRoutes] = useState([]); // 노선 데이터 조회
  const [carList, setCarList] = useState([]); // 버스 배차 조회
  const [selectedCardIndex, setSelectedCardIndex] = useState(null); // 배차 버스 중 선택한 버스 index
  const [dialogToggle, setDialogToggle] = useState(false);
  const [carList1, setCarList1] = useState([]); // 차량 콤보 조회
  const [selectChangeCarValue, setSelectChangeCarValue] = useState(""); // 선택한 대차
  const [radioValue, setRadioValue] = useState(""); // 적용회차 선택
  const [termsToggle, setTermsToggle] = useState(false); // 약관 동의 토글
  const [termsChecked, setTermsChecked] = useState(false); // 약관 동의 체크

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    const Interval = setInterval(() => {
      if (reloadTime == "00") {
        return;
      }
      if (selectBusValue) {
        SelectLogic1(selectBusValue);
      }
    }, Number(reloadTime) * 1000);
    return () => clearInterval(Interval);
  }, [selectBusValue]);

  const Init = async () => {
    try {
      let userData = null;
      await IndexedDb.GetLoginInfo().then((result) => {
        userData = result;
        setUserInfo(result);
      });
      console.log("userData: ", userData);
      if (!userData.infoYn || userData.infoYn == "N") {
        setTermsToggle(true);
        return;
      }
      await SelectLogic(); // 노선 데이터 조회
      if (bookmarkStates.bookmarks) {
        setSelectedBusTitle(bookmarkStates.busNo);
        setSelectBusValue(bookmarkStates.routeId);
        SelectLogic1(bookmarkStates.routeId);
      } else {
        setSelectedBusTitle("버스를 선택해주세요.");
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 노선 데이터 조회
  const SelectLogic = async () => {
    setLoading(true);
    let _routes = [];

    try {
      await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.GetCode, {
        code: "route",
        key1: "",
        key2: "",
        key3: "",
        key4: "",
      }).then((result) => {
        let data = result.data;
        // console.log("노선 데이터 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _routes.push(data[i]);
          }
          setRoutes(_routes);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 버스 배차 조회
  const SelectLogic1 = async (_param1) => {
    setLoading(true);
    let _carList = [];

    try {
      await Commons.Axios("get", Global.base.useUrl + Global.urls.ChangeCar.ChangeCar, {
        routeId: _param1,
      }).then((result) => {
        let data = result.data;
        console.log("버스 배차 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.result === "데이터가 없습니다.") {
          throw new Error(data.result);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _carList.push(data[i]);
          }
          setCarList(_carList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 차량 콤보 조회
  const SelectLogic2 = async () => {
    setLoading(true);
    let _carList = [];

    try {
      if (!selectBusValue) {
        throw new Error("노선을 선택해주세요.");
      } else if (!selectedCardIndex && selectedCardIndex !== 0) {
        throw new Error("회차를 선택해주세요.");
      }

      await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.GetCode, {
        code: "VEHICLE",
        key1: selectBusValue,
        key2: "",
        key3: "",
        key4: "",
      }).then((result) => {
        let data = result.data;
        console.log("차량 콤보 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _carList.push(data[i]);
          }
          setCarList1(_carList);
        }
      });
      setDialogToggle(true);
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 대차 처리
  const SaveLogic = async () => {
    setLoading(true);

    try {
      if (!selectChangeCarValue) {
        throw new Error("변경할 대차를 선택하세요.");
      } else if (!radioValue) {
        throw new Error("적용 회차를 선택하세요.");
      }

      await Commons.Axios("post", Global.base.useUrl + Global.urls.ChangeCar.Create, {
        opratDt: carList[selectedCardIndex].opratDt,
        routeId: selectBusValue,
        opratExchngYn: carList[selectedCardIndex].opratExchngYn,
        opratIdx: carList[selectedCardIndex].opratIdx,
        carId: carList[selectedCardIndex].vhcleId,
        newCarId: selectChangeCarValue,
        amPmDiv: radioValue,
      }).then((result) => {
        let data = result.data;
        console.log("대차 처리: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "Not Data") {
          setDialogToggle(false);
          throw new Error("데이터가 없습니다.");
        } else if (data === "Ok") {
          setDialogToggle(false);
          SelectLogic1(selectBusValue);
          setSelectChangeCarValue("");
          setRadioValue("");
          setSelectedCardIndex("");
          SelectLogic2();
          Commons.Toast("success", "대차 처리 되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 약관 동의
  const ApplyLogic = async () => {
    try {
      await Commons.Axios("post", Global.base.useUrl + Global.urls.Apply, {
        termsChecked: termsChecked,
      }).then((result) => {
        let data = result.data;
        console.log("약관 동의 결과: ", data);

        if (data === "Ok") {
          IndexedDb.UpdateDb("LoginInfo", userInfo.token, {
            ...userInfo,
            infoYn: "Y",
          });
          setTermsToggle(false);
        } else {
          throw new Error(data);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  return (
    <React.Fragment>
      <Card className='mb-2'>
        <Card.Body className='horizontal-card-body'>
          <Dropdown
            className='me-3'
            variant='outline-primary'
            title={selectedBusTitle}
            items={routes}
            value={selectBusValue}
            onChange={(e) => {
              console.log("e: ", e);
              setSelectBusValue(e);
              Commons.Storages("set", "saves", {
                ...Commons.Storages("get", "saves"),
                busNo: routes.filter((f) => f.value == e)[0].text,
                routeId: e,
              });
              SelectLogic1(e);
            }}
          />
          <Button
            className='me-3'
            size='sm'
            title={<FontAwesomeIcon icon={faStar} color={bookmarkStates.routeId === selectBusValue ? "#ffc301" : "#ffffff"} />}
            onClick={() => {
              if (selectBusValue === "") {
                return false;
              }
              if (selectBusValue !== bookmarkStates.routeId) {
                dispatch(BookmarkActions.setBusNo(routes.filter((f) => f.value == selectBusValue)[0].text));
                dispatch(BookmarkActions.setRouteId(selectBusValue));
                dispatch(BookmarkActions.setBookmarks(true));
              } else if (bookmarkStates.bookmarks || !selectBusValue) {
                dispatch(BookmarkActions.setBusNo("0"));
                dispatch(BookmarkActions.setRouteId("0"));
                dispatch(BookmarkActions.setBookmarks(false));
              } else {
                dispatch(BookmarkActions.setBusNo(routes.filter((f) => f.value == selectBusValue)[0].text));
                dispatch(BookmarkActions.setRouteId(selectBusValue));
                dispatch(BookmarkActions.setBookmarks(true));
              }
            }}
          />
          <Button size='sm' title={<FontAwesomeIcon icon={faRotateRight} onClick={() => SelectLogic1(selectBusValue)} />} />
        </Card.Body>
      </Card>
      <Card>
        <Card.Body className='custom-table-grid-header'>
          <Stack direction='horizontal'>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>회차</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>출발시간</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>차량번호</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-64'>승무원</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>비고</div>
          </Stack>
        </Card.Body>
      </Card>
      <div className='custom-table-grid-datas mb-3'>
        {carList.map((item, index) => {
          const CheckNumberCar = () => {
            if (index == 0) {
              return "custom-table-grid-datas-first";
            } else if (index == 1 || index == 2) {
              return "custom-table-grid-datas-next";
            } else {
              return "";
            }
          };

          const isSelected = index === selectedCardIndex;
          const selectedCardColor = isSelected ? "custom-table-grid-selected" : "";

          return (
            <Card key={index} className={`${CheckNumberCar()} ${selectedCardColor}`} onClick={() => setSelectedCardIndex(index)}>
              <Card.Body className='custom-table-grid-body'>
                <Stack direction='horizontal'>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-48'>{item.opratIdx}</div>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-80'>{item.caralcDtm}</div>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-80'>{item.vhcleNo}</div>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-64'>{item.name}</div>
                  <div
                    className='p-2 custom-table-grid-body-text custom-table-text-width-48'
                    style={{
                      fontSize: item.remark.length > 2 ? "12px" : "1rem",
                    }}
                  >
                    {item.remark}
                  </div>
                </Stack>
              </Card.Body>
            </Card>
          );
        })}
      </div>
      <div>
        <Button fullWidth title='대차처리' onClick={() => SelectLogic2()} />
      </div>
      <Dialog
        title={
          routes.length > 0 && routes.some((f) => f.value == selectBusValue) && carList.length > 0 && Number(selectedCardIndex)
            ? `${routes.find((f) => f.value == selectBusValue).text}번 ${carList[selectedCardIndex].opratIdx}회차`
            : ""
        }
        show={dialogToggle}
        onHide={() => setDialogToggle(false)}
        sumitButtonName='확인'
        onSumit={SaveLogic}
      >
        <Stack>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>배차 차량 변경</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>현재차량</span>
            <span>{carList.length > 0 && Number(selectedCardIndex) ? carList[selectedCardIndex].vhcleNo : ""}</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>대차</span>
            <Dropdown variant='outline-primary' title={"대차를 선택하세요."} items={carList1} value={selectChangeCarValue} onChange={(e) => setSelectChangeCarValue(e)} />
          </div>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>적용 회차</span>
          </div>
          <Radio
            items={[
              { value: "2", text: "금회" },
              { value: "0", text: "오전" },
              { value: "1", text: "오후" },
              { value: "3", text: "금일" },
            ]}
            value={radioValue}
            onChange={(e) => setRadioValue(e)}
          />
        </Stack>
      </Dialog>
      <Dialog
        fullscreen
        title='약관 동의'
        show={termsToggle}
        onHide={() => {}}
        sumitButtonName='동의'
        onSumit={() => {
          if (termsChecked) {
            ApplyLogic();
          } else {
            Commons.Toast("error", "약관 동의를 체크해주세요.");
          }
        }}
        closeButton={false}
        footerChildren={<Checkbox className='terms-checkbox' title='개인정보 수집 &#183; 이용에 동의합니다.' value={termsChecked} onChange={(e) => setTermsChecked(e)} />}
      >
        <Terms />
      </Dialog>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default ChangeCar;
